import { useTranslations } from "next-intl";
import { cn } from "@/lib/cn";

const sizeMap = {
  sm: "size-4 border-2",
  md: "size-5 border-2",
  lg: "size-8 border-[3px]",
} as const;

export interface SpinnerProps {
  size?: keyof typeof sizeMap;
  className?: string;
  /** Accessible label; defaults to the localized `common.loading`. */
  label?: string;
}

/**
 * Minimal ring spinner. Uses currentColor for the active arc so it inherits
 * the text color of its context (e.g. white on a pink button).
 */
export function Spinner({ size = "md", className, label }: SpinnerProps) {
  const t = useTranslations("common");
  return (
    <span
      role="status"
      aria-label={label ?? t("loading")}
      className={cn(
        "inline-block animate-spin rounded-full border-current/25 border-t-current align-[-0.125em]",
        sizeMap[size],
        className,
      )}
    />
  );
}
